import { render, staticRenderFns } from "./OfferRoute.vue?vue&type=template&id=6f726091&scoped=true&"
import script from "./OfferRoute.vue?vue&type=script&lang=js&"
export * from "./OfferRoute.vue?vue&type=script&lang=js&"
import style0 from "./OfferRoute.vue?vue&type=style&index=0&id=6f726091&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f726091",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VChip,VContainer,VDataTable,VIcon})
